import { CAST, blurbFor } from '@chessmate/persona';
import { usePersonaStore } from '../state/persona-store.js';

/**
 * The opponent picker (P3): every character, one tap to choose who plays the robot side. With a
 * single opponent seat the once-per-table rule is trivially satisfied; the table functions in
 * `@chessmate/persona` take over for multi-seat games later.
 */
export function PersonaPicker() {
  const personaId = usePersonaStore((s) => s.personaId);
  const setPersona = usePersonaStore((s) => s.setPersona);
  return (
    <div className="w-full rounded-3xl border-2 border-accent/30 bg-cream/95 p-4 lg:p-6 shadow-lg" data-testid="persona-picker">
      <h2 className="mb-3 text-xl font-extrabold text-ink">Your opponent</h2>
      <div className="flex flex-wrap gap-3">
        {CAST.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => setPersona(p.id)}
            aria-pressed={personaId === p.id}
            title={blurbFor(p.id, 'en') ?? p.name}
            className={`flex flex-col items-center gap-1 rounded-2xl p-1 ${personaId === p.id ? 'bg-accent/20 ring-2 ring-accent' : 'opacity-80 hover:opacity-100'}`}
            data-testid={`persona-${p.id}`}
          >
            <img src={p.portrait} alt={p.name} className="size-16 rounded-2xl object-cover sm:size-20 lg:size-24" />
            <span className="text-sm font-bold text-ink lg:text-base">{p.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
